'use client';

import Link from 'next/link';
import { menu } from './constants';
import styles from './network.module.scss';
import clsx from 'clsx';
import { getBlindMode } from '../../../../store/slices/blind-mode.slices';
import { useAppSelector } from '../../../../store/hooks';

export const Network = () => {
  const { blindWrapClass } = useAppSelector(getBlindMode);

  return (
    <aside className={styles.network}>
      <article className={clsx(styles.list, { [styles.blindWrapClass]: blindWrapClass })}>
        {menu.map(({ link, name }) => (
          <Link key={name} target="_blank" className={styles.link} href={link}>
            {name}
          </Link>
        ))}
      </article>
    </aside>
  );
};
